import { Button, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import DropZone from "../../../commons/dropZone/DropZone";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledSiniestralidad } from "../../../styled/Siniestros";

const validationSchema = Yup.object().shape({
  observaciones: Yup.string().max(
    5000,
    "El campo no puede superar los 5.000 caracteres"
  ),
});

const SiniestroAdjuntarDenunciaForm = ({
  open,
  handleClose,
  handleSubmit,
  siniestro,
  file,
  setFile,
}) => {

  const isAdjuntandoDenuncia = useSelector(
    (state) => state.siniestralidad.denunciaFirmada.loading
  );

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const initialValues = {
    idSiniestroCabecera: siniestro.idSiniestroCabecera,
    siniestroArt: siniestro.siniestroART,
    tipoSiniestro: siniestro.tipoSiniestro,
    nroDocumento: siniestro.nroDocumento,
    apellidoNombre: siniestro.apellidoNombre,
    observaciones: "",
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
      <DialogTitle>Adjuntar Denuncia</DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit({ ...values, file })}
      >
        {({ values }) => (
          <Form>
            {isAdjuntandoDenuncia ? (
              <StyledSiniestralidad.FormLoading>
                <CircularLoading />
              </StyledSiniestralidad.FormLoading>
            ) : (
              <StyledSiniestralidad.FormContent>
                <StyledSiniestralidad.FormRow>
                  <FormikTextField
                    fullWidth={true}
                    name="siniestroArt"
                    label="Nro Siniestro"
                    type="text"
                    disabled
                  />
                  <FormikTextField
                    fullWidth={true}
                    name="tipoSiniestro"
                    label="Tipo Siniestro"
                    type="text"
                    disabled
                  />
                </StyledSiniestralidad.FormRow>
                <StyledSiniestralidad.FormRow>
                  <FormikTextField
                    fullWidth={true}
                    name="nroDocumento"
                    label="Número Documento"
                    type="text"
                    disabled
                  />
                  <FormikTextField
                    fullWidth={true}
                    name="apellidoNombre"
                    label="Apellido y Nombre"
                    type="text"
                    disabled
                  />
                </StyledSiniestralidad.FormRow>
                <StyledSiniestralidad.FormObservaciones>
                  <FormikTextField
                    fullWidth={true}
                    name="observaciones"
                    label="Observaciones"
                    type="text"
                    variant="outlined"
                    multiline
                    maxRows={15}
                    minRows={2}
                  />
                  {values.observaciones.length > 0 && (
                    <Typography variant="caption">
                      {values.observaciones.length} caracteres
                    </Typography>
                  )}
                </StyledSiniestralidad.FormObservaciones>
                <DropZone
                  file={file}
                  setFile={setFile}
                  loading={false}
                  maxFiles={5}
                  extension=".PDF, .JPG o .PNG"
                  accept={{
                    "application/pdf": [".pdf"],
                    "image/jpeg": [".jpg"],
                    "image/png": [".png"],
                  }}
                  dropZoneText="Arrastre aquí o haga click en el recuadro para importar información en formato PDF, JPG, PNG"
                  dropZoneEditText="Si desea subir mas archivos arrastrelos nuevamente o haga click en el recuadro."
                />
                <ConfirmDialog
                  open={openConfirmDialog}
                  handleClose={() => {
                    setOpenConfirmDialog(false);
                  }}
                  handleConfirm={() => {
                    setOpenConfirmDialog(false);
                    handleClose();
                  }}
                  title="Cancelar Adjuntar Denuncia"
                  warningText={
                    "Al cerrar el formulario, perderá todos los datos completados. ¿Está seguro que desea cerrar el formulario?"
                  }
                  loading={false}
                />
              </StyledSiniestralidad.FormContent>
            )}
            <StyledSiniestralidad.FormButtonsContainer>
              <Button
                variant="outlined"
                onClick={() => {
                  // Solamente mostrar el popup de confirmación
                  //  si el usuario completó algunos datos del formulario
                  if (!!values.observaciones || file) {
                    setOpenConfirmDialog(true);
                  } else {
                    handleClose();
                  }
                }}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                // Por especificacion, es OBLIGATORIO adjuntar un archivo.
                disabled={isAdjuntandoDenuncia || !file}
              >
                Enviar
              </Button>
            </StyledSiniestralidad.FormButtonsContainer>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default SiniestroAdjuntarDenunciaForm;
